// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import VueMeta from 'vue-meta'
import VueFirestore from 'vue-firestore'
import VueCurrencyFilter from 'vue-currency-filter'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VCard,
  VAvatar,
  VTextField,
  VChip,
  VForm,
  VDivider,
  VMenu,
  VImg,
  VDialog,
  VAutocomplete,
  VSelect,
  VBadge
} from 'vuetify'
import '../node_modules/vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VCard,
    VAvatar,
    VTextField,
    VChip,
    VForm,
    VDivider,
    VMenu,
    VImg,
    VDialog,
    VAutocomplete,
    VSelect,
    VBadge
  },
  theme: {
    primary: '#145900',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})
Vue.use(VueFirestore)
Vue.use(VueMeta)
Vue.use(VueCurrencyFilter,
  {
    symbol: 'CDF',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })
Vue.config.productionTip = false
var config = {
  apiKey: 'AIzaSyDYV4EMLqnctndl6cza-xmcCkYZiR5Itfs',
  authDomain: 'ligablofoods.firebaseapp.com',
  databaseURL: 'https://ligablofoods.firebaseio.com',
  projectId: 'ligablofoods',
  storageBucket: 'ligablofoods.appspot.com',
  messagingSenderId: '729827769103'
}
const firebaseApp = firebase.initializeApp(config)
const firestore = firebaseApp.firestore()
firestore.settings({timestampsInSnapshots: true})
// export firestore db link
export default firestore
export const db = firebase.firestore()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  beforeCreate () {
    store.dispatch('fetchProducers')
    store.dispatch('FECTH_PRODUCTS')
    store.dispatch('fetchCategory')
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        store.dispatch('FETCH_USER_DATA')
        store.dispatch('AUTO_SIGNIN', user)
        store.dispatch('fetchProducers')
        store.dispatch('fetchCategory')
      }
    })
  },
  created () {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        store.dispatch('LOAD_SHOPPING_CART_ITEMS', user)
        console.log('sferfgrgrgrtgrgt' + JSON.stringify(user))
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js